import React from 'react';
import { CheckCircle2, Clock, Rocket, Sparkles } from 'lucide-react';
import siteConfig from '../config/contentConfig';

const Roadmap = () => {
  const statusConfig = {
    completed: {
      icon: CheckCircle2,
      color: 'text-[#32B44A]',
      bgColor: 'bg-[#32B44A]/20',
      label: 'Completed',
    },
    active: {
      icon: Rocket,
      color: 'text-blue-400',
      bgColor: 'bg-blue-400/20',
      label: 'Active',
    },
    upcoming: {
      icon: Sparkles,
      color: 'text-purple-400',
      bgColor: 'bg-purple-400/20',
      label: 'Future',
    },
  };

  return (
    <section
      id="roadmap"
      data-testid="roadmap-section"
      className="section-container bg-[#0C0E12]"
    >
      <div className="text-center space-y-4 mb-16">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
          <span className="text-[#32B44A]">{siteConfig.token.symbol}</span>{' '}
          Roadmap
        </h2>
        <div className="w-24 h-1 bg-[#FFD600] mx-auto rounded-full" />
        <p className="text-slate-300 max-w-3xl mx-auto text-lg">
          Our journey from launch to the moon! Here's what we've accomplished and what's coming next for the $NANA ecosystem.
        </p>
      </div>

      {/* Vertical Timeline */}
      <div className="max-w-4xl mx-auto relative">
        {/* Timeline Line */}
        <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-[#32B44A] via-blue-400 to-purple-400" />

        <div className="space-y-12">
          {siteConfig.roadmap.map((phase, index) => {
            const config = statusConfig[phase.status];
            const Icon = config.icon;
            const isEven = index % 2 === 0;

            return (
              <div
                key={phase.phase}
                data-testid={`roadmap-phase-${phase.phase}`}
                className={`relative grid grid-cols-1 md:grid-cols-2 gap-8 items-center ${
                  isEven ? '' : 'md:flex-row-reverse'
                }`}
              >
                {/* Timeline Dot */}
                <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-6 h-6 rounded-full bg-[#FFD600] border-4 border-[#0C0E12] z-10" />

                {/* Content Card */}
                <div className={isEven ? 'md:pr-12' : 'md:pl-12 md:col-start-2'}>
                  <div className="glass rounded-2xl p-6 sm:p-8 card-hover border border-yellow-500/20">
                    {/* Phase Badge */}
                    <div className="flex items-center justify-between mb-4">
                      <span className="text-xs uppercase tracking-widest font-semibold text-yellow-400/90">
                        Phase {phase.phase}
                      </span>
                      <div className={`flex items-center space-x-2 px-3 py-1 rounded-full ${config.bgColor}`}>
                        <Icon size={14} className={config.color} />
                        <span className={`text-xs font-semibold ${config.color}`}>
                          {config.label}
                        </span>
                      </div>
                    </div>

                    {/* Title */}
                    <h3 className="text-xl sm:text-2xl font-bold mb-4">
                      {phase.title}
                    </h3>

                    {/* Items */}
                    <ul className="space-y-2">
                      {phase.items.map((item, i) => (
                        <li key={i} className="flex items-start space-x-2 text-slate-300">
                          <span className="text-[#FFD600] mt-1">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Community CTA */}
      <div className="max-w-4xl mx-auto mt-16">
        <div className="glass rounded-3xl p-8 sm:p-12 text-center border border-yellow-500/30 card-hover bg-gradient-to-br from-[#FFD600]/10 to-transparent">
          <h3 className="text-2xl sm:text-3xl font-black mb-4">
            🚀 Want to be part of our journey to the moon?
          </h3>
          <p className="text-lg text-slate-300 mb-6">
            Join our community and help shape the future of $NANA!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.open(siteConfig.links.telegram, '_blank')}
              className="px-8 py-3 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-lg btn-press transition-colors"
            >
              Join Telegram
            </button>
            <button
              onClick={() => window.open(siteConfig.links.twitter, '_blank')}
              className="px-8 py-3 bg-black hover:bg-gray-900 text-white font-bold rounded-lg btn-press transition-colors"
            >
              Follow X
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
